/* eslint-disable max-len */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useCallback, useMemo, useRef, useContext } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Row,
} from 'reactstrap';

import AlertModal from '../../components/AlertModal';
import TipoDeAtendimento from '../../components/Especialidade';
import ModalFinanceiroEspecialidadeUso from '../../components/ModalFinanceiroEspecialidadeUso/index';
import TableManager from '../../components/TableManager';
import { AppContext } from '../../contexts/app';
import { useManager } from '../../hooks/manager';
import api from '../../services/api';

// nome anterior Especialidades - alterado para TipoDeAtendimentos 17/11/2023 18:13
function TipoDeAtendimentos() {
  const notificationRef = useRef();
  const confirmViewAccountsRef = useRef();
  const modalFinanceiroEspecialidadeUsoRef = useRef();
  const { setLoading } = useContext(AppContext);
  const especialidadeRef = useRef();
  const { load, destroy } = useManager();

  useEffect(() => {
    load('/especialidades', 1, [], 10, { status: 'ativo' });
  }, [load]);

  const handleUpdate = useCallback((data) => {
    especialidadeRef.current.show(data);
  }, []);

  const handleCreate = useCallback(() => {
    especialidadeRef.current.show();
  }, []);

  const handleDeleteError = useCallback((error) => {
    const responseData = error?.response?.data;
    const message = responseData?.message;
    const list = responseData?.list;

    if (message && Array.isArray(list) && list.length > 0) {
      confirmViewAccountsRef.current.show({
        title: 'Não foi possível excluir',
        message,
        confirmText: 'Visualizar contas',
        confirmColor: 'primary',
        cancelText: 'Fechar',
        cancelColor: 'secondary',
        onConfirm: () => {
          confirmViewAccountsRef.current.close();
          modalFinanceiroEspecialidadeUsoRef.current.show({
            title: 'Contas vinculadas ao tipo de atendimento',
            accounts: list,
          });
        },
      });
    }
  }, []);

  const handleCreateCsv = useCallback((_selectedRows = []) => {
    (async () => {
      try {
        setLoading({
          loading: true,
          message: 'Aguarde... Estamos gerando o arquivo CSV... ',
        });

        // await fetch api
        const res = await api.post('/tipoAtendimentoCSVCreatorReportLists', { tipoAtendimentosIds: _selectedRows.map(({ _id }) => _id) }, { responseType: 'blob' });
        const fileName = res.headers['content-disposition']
          .replace('attachment; filename=', '')
          .replace('"', '');

        const fileURL = window.URL.createObjectURL(res.data);
        const alink = document.createElement('a');
        alink.href = fileURL;
        alink.target = '_blank';
        alink.rel = 'noopener noreferrer';
        alink.download = fileName;
        alink.click();

        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao realizar ao gerar relatório',
          color: 'danger',
        });
      }
    })();
  }, [notificationRef, setLoading]);

  const formattedName = useCallback((row) => {
    if (row?.status === 'inativo') {
      return (
        <div>
          <span className="mr-2">{row.nome}</span>
          <span className="badge bg-danger">
            Inativo
          </span>
        </div>
      );
    }

    return (
      <div>
        <span>{row.nome}</span>
      </div>
    );
  }, []);

  const columns = useMemo(() => [
    {
      dataField: 'nome',
      text: 'Nome',
      textFilter: true,
      width: '200px',
      formatter: formattedName,
    },
    /* {
      dataField: 'cor',
      text: 'Cor',
      formatter: (row) => (
        <div style={{ backgroundColor: row.cor, width: '20px', height: '20px', borderRadius: '10px' }} />
      ),
      width: '100%',
    }, */
  ]);

  const actions = useMemo(() => [
    {
      name: 'inactivate',
      tooltip: 'Inativar',
      color: 'danger',
      className: (row) => (row?.status === 'inativo' ? 'd-none mt-2 mr-2' : 'mt-2 mr-2'),
      icon: 'fa-solid fa-ban',
      onClick: (row) => destroy(row._id, '/especialidades-inactivate', null, null, { removeFromDatas: false, notificationSuccessMessage: 'Inativado com sucesso' }),
    },
    {
      name: 'activate',
      tooltip: 'Ativar',
      color: 'success',
      className: (row) => (row?.status === 'inativo' ? 'mt-2 mr-2' : 'd-none mt-2 mr-2'),
      icon: 'fa-solid fa-circle-check text-white',
      onClick: (row) => destroy(row._id, '/especialidades-activate', null, null, { removeFromDatas: false, message: 'Tem certeza que deseja ativar?', confirmText: 'Ativar', confirmColor: 'success', notificationSuccessMessage: 'Ativado com sucesso' }), // esse ativar é ativar
    },
    {
      name: 'delete',
      tooltip: 'Excluir',
      color: 'danger',
      className: 'mt-2 mr-2',
      icon: 'fa-solid fa-trash',
      onClick: (row) => destroy(row._id, '/especialidades', null, handleDeleteError, {
        removeFromDatas: true,
        message: 'Tem certeza que deseja excluir?',
        confirmText: 'Excluir',
        notificationSuccessMessage: 'Excluído com sucesso',
        skipDefaultErrorHandler: true,
      }), // esse deletar é excluir
    },
  ], [handleDeleteError]);

  return (
    <Container fluid>
      <Row className="mt-5">
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h3>Tipo de Atendimentos</h3>
                </Col>
              </Row>
            </CardBody>
            <CardFooter>
              <Row>
                <Col>
                  <Row>
                    <Col xs={12} sm={5} md={3} className="mb-3 mb-xl-0">
                      <Button block color="success" onClick={handleCreate}>
                        Cadastrar
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <TableManager
            initialColumns={columns}
            onCreateCsv={handleCreateCsv}
            onUpdate={(row) => handleUpdate(row)}
            selectable
            actionsWidth="500px"
            actions={actions}
            enableStatusQueryFilter
          />
        </Col>
      </Row>
      <AlertModal ref={confirmViewAccountsRef} />
      <ModalFinanceiroEspecialidadeUso ref={modalFinanceiroEspecialidadeUsoRef} />
      <TipoDeAtendimento ref={especialidadeRef} />
    </Container>
  );
}

export default TipoDeAtendimentos;
